import WidgetModule from "@eisinc/Overrides/Widgets/Basic/SocialLinks";

export * from "@eisinc/Overrides/Widgets/Basic/SocialLinks";

export default WidgetModule;
